import Navbar from '../../components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CredibilityBar from './components/CredibilityBar';
import PlaceholderSection from './components/PlaceholderSection';

export default function Home() {
  return (
    <div className="relative">
      <Navbar />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Credibility Bar */}
      <CredibilityBar />
      
      {/* Placeholder sections for future development */}
      <PlaceholderSection id="who-its-for" title="Is Edbilities Right for You?" />
      <PlaceholderSection id="the-problem" title="The Problem" />
      <PlaceholderSection id="what-we-do" title="What Edbilities Helps You Do" />
      <PlaceholderSection id="why-it-works" title="Why This Works When Other Courses Didn't" />
      <PlaceholderSection id="professional-english" title="What We Mean by Professional English" />
      <PlaceholderSection id="how-it-works" title="How It Works" />
      <PlaceholderSection id="expect-change" title="What You Can Expect to Change" />
      <PlaceholderSection id="testimonials" title="Testimonials" />
      <PlaceholderSection id="offer" title="What You Get" />
      <PlaceholderSection id="faqs" title="FAQs" />
      <PlaceholderSection id="team" title="Meet the Team" />
      <PlaceholderSection id="cta" title="Final CTA" />
    </div>
  );
}
